module.exports = __webpack_public_path__ + "img/details_sub.59358ca3.jpg";